/**
 * Angular imports.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

/**
 * Modal imports.
 */
import { FeedDetailData, HomeFeedListData, SpecialityListData } from '../../onboarding/interface/apiResponse.model';

/**
 * Service imports.
 */
import { AuthService } from '../../auth/auth.service';

/**
 * Rxjs imports.
 */
import { Subject, Observable } from 'rxjs';

/**
 * Constant imports.
 */
import { API } from '../../constants/api.constants';

/**
 * Get Web Service.
 */
@Injectable({
  providedIn: 'root'
})
export class GetwebService {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public feed_obj: Subject<any> = new Subject();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public feed_unbookmarked: Subject<any> = new Subject();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public journal_unbookmarked: Subject<any> = new Subject();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public active_custom_id: Subject<any> = new Subject();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public bookmarked_list_for: Subject<any> = new Subject();
  public lang = 'en';
  private token: string;

  /**
   * Necessary instances.
   */
  constructor(private httpClient: HttpClient, private authService: AuthService) {
    this.token = this.authService.getToken();
  }

  /**
   * Get feed List
   */
  getfeedList(offset, feedFilter): Observable<HomeFeedListData> {
    feedFilter = (JSON.stringify(feedFilter));
    const params = { 'offset': offset, feedFilter: feedFilter };

    return this.httpClient.get<HomeFeedListData>(API.HOME_DATA_LISTS, {
      params: params
    });
  }

  /**
   * Get Feed Detail
   */
  getfeedetail(feed_id): Observable<HomeFeedListData> {
    const params = { feed_id: feed_id };

    return this.httpClient.get<HomeFeedListData>(API.HOME_FEED_DETAIL, {
      params: params
    });
  }

  /**
   * Get Feed Detail New
   */
  getfeedetailNew(feed_id, ec_id?): Observable<FeedDetailData> {
    if (ec_id) {
      return this.httpClient.get<FeedDetailData>(API.FEED_DETAIL_V4, {
        params: { feed_id, ec_id }
      });
    } else {
      return this.httpClient.get<FeedDetailData>(API.FEED_DETAIL_V4, {
        params: { feed_id }
      });
    }
  }

  /**
   * Get Timeline List
   */
  gettimelineList(offset, custom_id): Observable<HomeFeedListData> {
    const params = { 'offset': offset, custom_id: custom_id };

    return this.httpClient.get<HomeFeedListData>(API.HOME_FEED_TIMELINE, {
      params: params
    });
  }

  /**
   * Get Bookmark List
   */
  getbookmarkList(offset, custom_id): Observable<HomeFeedListData> {
    const params = { 'offset': offset, custom_id: custom_id };

    return this.httpClient.get<HomeFeedListData>(API.HOME_FEED_ARCHIEVE, {
      params: params
    });
  }

  /**
   * Get Journal Bookmark List
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getJournalBookmarkList(offset): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.httpClient.get<any>(API.JOURNAL_ARCHIVE, {
      params: { offset: offset }
    });
  }

  /**
   * Get Archieve List
   */
  getArchieveList(product_type, offset): Observable<HomeFeedListData> {
    const params = { product_type: product_type, offset: offset };

    return this.httpClient.get<HomeFeedListData>(API.ARCHIEVE_LIST, {
      params: params
    });
  }

  /**
   * Get Media List
   */
  getMediaList(offset, custom_id): Observable<HomeFeedListData> {
    const params = { 'offset': offset, custom_id: custom_id };

    return this.httpClient.get<HomeFeedListData>(API.PROFILE_MEDIA_LIST, {
      params: params
    });
  }

  /**
   * Get Question List
   */
  getQuestionList(offset, custom_id): Observable<HomeFeedListData> {
    const params = { offset: offset, custom_id: custom_id, safe_url: '' };

    return this.httpClient.get<HomeFeedListData>(API.USER_PROFILE_QUESTION_LIST, {
      params: params
    });
  }

  /**
   * Get Speciality List
   */
  getSpecialityList(): Observable<SpecialityListData> {
    return this.httpClient.get<SpecialityListData>(API.SPECIALITY_LIST);
  }

  /**
   * Set Product Value.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setProductValue(feed: any): void {
    this.feed_obj.next(feed);
  }

  /**
   * Get Product Value.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getProductValue(): Subject<any> {
    return this.feed_obj;
  }

  /**
   * Get Feed Meta
   */
  getFeedMeta(meta_url): Observable<HomeFeedListData> {
    return this.httpClient.get<HomeFeedListData>(API.CONNECT_WEB_SERVICE_GET, {
      params: { rquest: 'meta_preview', 'user_auth_key': this.token, 'meta_url': meta_url, 'type_for': 'feed', 'app_version': '1.0' }
    });
  }

  /**
   *  get posting filter association and channel
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getPotingFilter(): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.httpClient.get<any>(API.HOME_POSTING_ON);
  }

  /**
   * bookmark list
   */
  getBookmarkList(offset, product_type): Observable<HomeFeedListData> {
    const params = { offset: offset, product_type: product_type };

    return this.httpClient.get<HomeFeedListData>(API.FEED_DETAIL_V4, {
      params: params
    });
  }
}
